const imgUrl = {
  dureLogo: require("./logo-dure.png"),
  globalReachMap: require("./globalReachMap.svg"),
  productOfferImg: require("./productOffering.png"),
  mapPoint:require('../images/mapPoint.png'),
  bot:require('../images/bot.png'),

  nigeriamohLogo: require('../images/LogoSwiper/nigeriamoh.png'),
  qatarLogo: require('../images/LogoSwiper/qatar.png'),
  santeLogo: require('../images/LogoSwiper/sante.png'),
  bankGroupLogo:require('../images/LogoSwiper/worldBankGroup.png'),
  kweLogo:require('../images/LogoSwiper/kwe.png'),
  gaviLogo: require('../images/LogoSwiper/gavi.png'),
  isaLogo:require('../images/LogoSwiper/isa.png'),
  stoptblogo:require('../images/LogoSwiper/stoptb.png'),
  globalfundLogo:require('../images/LogoSwiper/theglobalfund.png'),
  whologo:require('../images/LogoSwiper/whologo.png'),
  novonordiskLogo:require('../images/LogoSwiper/novonordisk.png'),

  galleryMeeting:require('../images/gallery/meeting.png'),
  dureBrochureImg1:require('../images/gallery/dureBrochure1.png'),
  galleryImg2:require('../images/gallery/2.png'),
   galleryImg3:require('../images/gallery/3.png'),
  galleryImg4:require('../images/gallery/4.png'),
  galleryImg5:require('../images/gallery/5.png'),
  galleryImg6:require('../images/gallery/6.png'),
  galleryImg7:require('../images/gallery/7.png'),
  galleryImg8:require('../images/gallery/8.png'),
  galleryImg9:require('../images/gallery/9.png'),
  galleryImg10:require('../images/gallery/10.png'),
  galleryImg11:require('../images/gallery/11.png'),
  galleryImg12:require('../images/gallery/12.png'),
  galleryImg13:require('../images/gallery/13.png'),
  galleryImg14:require('../images/gallery/14.png'),
  galleryImg15:require('../images/gallery/15.png'),
  galleryImg16:require('../images/gallery/16.png'),

  contactMap:require('../images/contactMap.png'),

  // footer social media icons
  twitterIcon:require('../images/footer/twitter.png'),
  mailIcon:require('../images/footer/mail.png'),
  linkedInIcon:require('../images/footer/linkedin.png'),

  productDashboardImg:require('../images/ProductPage/productDashboard.png'),
  childDiabetesImg:require('../images/ProductPage/childhoodType.png'),
  survelienceImg:require('../images/ProductPage/survellience.png'),
  communityImg:require('../images/ProductPage/community.png'),
  circleImage1:require('../images/CircleChartImages/Infrastructure.png'),
  circleImage2:require('../images/CircleChartImages/OpemLMIS.png'),
  circleImage3:require('../images/CircleChartImages/Unitised-Digital-Transformation.png'),
  circleImage4:require('../images/CircleChartImages/Workflow-based-monitoring.png'),
  circleImage5:require('../images/CircleChartImages/ai-as-practice.png'),
  circleImage6:require('../images/CircleChartImages/case-based-survaillaince.png'),
  circleImage7:require('../images/CircleChartImages/climate-and-health.png'),
  circleImage8:require('../images/CircleChartImages/community-led-monitoring.png'),  
  circleImage9:require('../images/CircleChartImages/situation-room.png'),

  countriesList:require('../images/countries.png'),
  countriesListMobile:require('../images/countriesMobile.png'),
  
  dure_logo_symbol : require('../images/dure-logo-symbol.png'),

  downloadIcon:require('../images/download_icon.png'),

  // openlmis images

  openLmisdashboard:require('../images/OpenLmisPage/openLmis_dashboard.png'),
  integratedSymbol:require('../images/OpenLmisPage/integrated.png'),
  aiSymbol:require('../images/OpenLmisPage/ai.png'),
  analyticsSymbol:require('../images/OpenLmisPage/analytics.png'),
  multichannelSymbol:require('../images/OpenLmisPage/multichannel.png'),
  countrySymbol:require('../images/OpenLmisPage/countryOwned.png'),
  afghanistanKid:require('../images/OpenLmisPage/afghanistanKid.png'),
  carBg:require('../images/OpenLmisPage/car.png'),
  afghanistanKidcircular:require('../images/OpenLmisPage/kidTablet.png'),
  carCircular:require('../images/OpenLmisPage/carTablet.png')
};

export default imgUrl;